import React, { createContext, ReactElement, useState } from 'react'

interface WebGLProps {
  assetVizRenderingMap: Map<string, ReactElement>
  setAssetVizRenderingMap: React.Dispatch<
    React.SetStateAction<Map<string, ReactElement>>
  >
}

export const WebGLLayer: React.FC<{ children: React.ReactNode }> = (props) => {
  const { children } = props
  const [assetVizRenderingMap, setAssetVizRenderingMap] = useState<
    Map<string, ReactElement>
  >(new Map())
  return (
    <WebGLContext.Provider
      value={{
        assetVizRenderingMap: assetVizRenderingMap,
        setAssetVizRenderingMap: setAssetVizRenderingMap,
      }}>
      {children}
    </WebGLContext.Provider>
  )
}

export const WebGLContext = createContext<WebGLProps>(null!)
